import { FadeIn } from '../../components/ui/AnimatedSection';
import { useTranslation } from 'react-i18next';

export default function FounderSection() {
  const { t } = useTranslation();

  return (
    <section className="py-32 bg-black-deep text-white" id="fondatrice">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          
          <FadeIn>
            <div className="relative aspect-[4/5] max-w-md mx-auto">
              <div className="absolute inset-0 bg-gold-500 translate-x-4 translate-y-4"></div>
              <img 
                src="/assets/johanna.webp" 
                alt={t('home.founder.alt')} 
                className="relative z-10 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
          </FadeIn>

          <FadeIn delay={0.2}>
            <span className="text-gold-400 font-script text-3xl mb-4 block">{t('home.founder.tag')}</span>
            <h2 className="text-4xl md:text-5xl font-serif mb-8 leading-tight">{t('home.founder.title1')} <br/>{t('home.founder.title2')}</h2>
            
            <div className="space-y-6 text-gray-300 font-light leading-relaxed">
              <p>{t('home.founder.p1')}</p>
              <p>{t('home.founder.p2')}</p>
              <p>{t('home.founder.p3')}</p>
            </div>

            <div className="mt-12 pt-8 border-t border-white/10">
              <div className="font-serif text-xl tracking-widest text-gold-500">{t('home.founder.name')}</div>
              <div className="text-xs uppercase tracking-widest text-gray-500 mt-1">{t('home.founder.role')}</div>
            </div>
          </FadeIn>

        </div>
      </div>
    </section>
  );
}
